<script setup lang="ts">
import ImageAudioVideo from '../../bubble/ImageAudioVideo.vue';
import { useI18n } from 'vue-i18n';

import type { IOrderItem, IOrderMessage } from './types';

const props = defineProps<{
  detail: IOrderItem;
  showTotalAmount?: string;
  labels?: IOrderMessage['labels'];
}>();

const { showTotalAmount, detail, labels } = props ?? {};
const { title, count, coverImage } = detail ?? {};

const { t } = useI18n();

const attachment = {
  file_type: 'image',
  data_url: coverImage,
  width: 58,
  height: 78,
};

const totalLabel = labels?.total ?? t('CONVERSATION.CARD_MESSAGE.ORDER.TOTAL');
</script>

<template>
  <div class="item-info">
    <ImageAudioVideo :attachment="attachment" />
    <div class="item-info-content">
      <div>{{ title }}</div>
      <div class="price-container">
        <span>x{{ count }}</span>
        <span class="price-total">
          <span>{{ totalLabel }}:</span>
          <span class="price-total-value">{{ showTotalAmount }}</span>
        </span>
      </div>
    </div>
  </div>
</template>

<style scoped>
.item-info {
  height: 78px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.item-info-content {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}

.price-container {
  display: flex;
  align-items: center;
  gap: 10px;
}

.price-total {
  display: flex;
  align-items: center;
  gap: 4px;
}

.price-total-value {
  font-size: 14px;
  font-weight: 600;
  margin-left: 4px;
}
</style>
